import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { checkFilterItem, fetchFilterData } from "../../../utils/fetchFilterData";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import DefaultButton from "../../styles/materialButtonStyle";
import PageSpinner from "../spinner/PageSpinner";
import Notification from "../notification/Notification";
import getUserInfo from "../../../utils/getUserInfo";
import { useTranslation } from "react-i18next";

import {
  StyledBlockAction,
  StyledBlockLabel,
  StyledFormBlock,
  StyledFormGrid,
  StyledInputBlock
} from "../../styles/styledTabsForm";
import { parseAxiosError } from "../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../utils/consts";

const UserInfo = () => {
  const { t } = useTranslation("accountPage");
  const history = useHistory();

  const [user, setUser] = useState(null);
  const [userData, setUserData] = useState({
    firstname: null,
    lastname: null
  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const filterData = {
    "currentTab": checkFilterItem(history, "currentTab", "user-info", false, true),
  };

  useEffect(() => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/users/" + getUserInfo()["userId"], userAuthenticationConfig()).then(response => {
      setUser(response.data);
      setUserData({ firstname: response.data.firstname, lastname: response.data.lastname });
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();

    axios.put("/api/users/" + user.id, userData, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setUser(response.data);
        setUserData({ firstname: response.data.firstname, lastname: response.data.lastname });
        setNotification({ ...notification, visible: true, type: "success", message: t("account.success") });
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  if (!user) {
    return <PageSpinner
      position="center"
      pt="60"
      pb="60"
    />;
  }

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledFormGrid
        pt="20"
        as="form"
        onSubmit={handleSubmit}
        className="grid-form"
      >
        <StyledFormBlock>
          <StyledBlockLabel>
            {t("account.title")}
          </StyledBlockLabel>
          <StyledInputBlock>
            <TextField
              className="grid-form__input"
              id="email"
              label="Email"
              value={user.email}
              variant="filled"
              InputProps={{
                readOnly: true
              }}
            />
            <TextField
              className="grid-form__input"
              id="firstname"
              label={t("account.firstname")}
              value={userData.firstname}
              onChange={event => {setUserData({ ...userData, firstname: event.target.value });}}
              variant="filled"
              required
              inputProps={{ maxLength: 100 }}
            />
            <TextField
              className="grid-form__input"
              id="lastname"
              label={t("account.lastname")}
              value={userData.lastname}
              onChange={event => {setUserData({ ...userData, lastname: event.target.value });}}
              variant="filled"
              required
              inputProps={{ maxLength: 100 }}
            />
          </StyledInputBlock>
          <div className="clear-column" />
        </StyledFormBlock>
        <StyledFormBlock>
          <div className="clear-column" />
          <StyledBlockAction>
            <DefaultButton
              color="success"
              type="submit"
              disabled={user.firstname === userData.firstname && user.lastname === userData.lastname}
            >
              {t("account.save")}
            </DefaultButton>
          </StyledBlockAction>
          <div className="clear-column" />
        </StyledFormBlock>
      </StyledFormGrid>
    </>
  );
};

export default UserInfo;